import { PatientData } from '../types/patientData.ts';

interface PatientSlice {
    patientData: PatientData;
    setPatientData: (data: PatientData) => void;
    resetPatient: () => void;
}

const createPatientSlice = (set: any) => ({
    patientData: {
        firstname: null,
        lastname: null,
        pnr: null,
    },
    setPatientData: (data: PatientData) => set({ patientData: data }),
    resetPatient: () =>
        set({
            patientData: {
                firstname: null,
                lastname: null,
                pnr: null,
            },
        }),
});

export { createPatientSlice };
export type { PatientData, PatientSlice };
